import React from "react";

const roles = [
  {
    name: "Administrators",
    freeShipping: false,
    taxExempt: false,
    active: true,
    isSystemRole: true,
  },
  {
    name: "Forum Moderators",
    freeShipping: false,
    taxExempt: false,
    active: true,
    isSystemRole: true,
  },
  {
    name: "Registered",
    freeShipping: false,
    taxExempt: false,
    active: true,
    isSystemRole: true,
  },
  {
    name: "Guests",
    freeShipping: false,
    taxExempt: false,
    active: true,
    isSystemRole: true,
  },
  {
    name: "Vendors",
    freeShipping: false,
    taxExempt: false,
    active: true,
    isSystemRole: true,
  },
];

function IconCheck() {
  return <span className="text-blue-600 text-2xl">&#10003;</span>;
}
function IconCross() {
  return <span className="text-red-600 text-2xl">&#10005;</span>;
}

export default function CustomerRolesTable() {
  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="flex flex-wrap items-center justify-between mb-8">
          <h1 className="text-3xl font-bold">Customer roles</h1>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-lg flex items-center gap-2 text-xl">
            <span className="text-2xl">+</span> Add new
          </button>
        </div>
        <p className="mb-4 text-lg">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            customer roles
          </a>
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full border-2 border-gray-300 rounded-lg text-gray-900 text-lg">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-4 px-8 font-bold text-left text-xl">Name</th>
                <th className="py-4 px-8 font-bold text-xl">Free shipping</th>
                <th className="py-4 px-8 font-bold text-xl">Tax exempt</th>
                <th className="py-4 px-8 font-bold text-xl">Active</th>
                <th className="py-4 px-8 font-bold text-xl">Is system role</th>
                <th className="py-4 px-8 font-bold text-xl"></th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role, idx) => (
                <tr
                  key={role.name}
                  className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="py-4 px-8 text-xl">{role.name}</td>
                  <td className="py-4 px-8 text-center">
                    {role.freeShipping ? <IconCheck /> : <IconCross />}
                  </td>
                  <td className="py-4 px-8 text-center">
                    {role.taxExempt ? <IconCheck /> : <IconCross />}
                  </td>
                  <td className="py-4 px-8 text-center">
                    {role.active ? <IconCheck /> : <IconCross />}
                  </td>
                  <td className="py-4 px-8 text-center">
                    {role.isSystemRole ? <IconCheck /> : <IconCross />}
                  </td>
                  <td className="py-4 px-8 text-center">
                    <button className="bg-gray-200 hover:bg-gray-300 rounded-lg px-6 py-2 flex items-center gap-2 text-lg">
                      <svg
                        className="w-6 h-6 text-gray-700"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.232 5.232l3.536 3.536M16.732 3.732A2.504 2.504 0 0120.217 7.22l-11 11a4 4 0 01-1.414.943l-4.207 1.402 1.402-4.207a4 4 0 01.943-1.414l11-11z"
                        ></path>
                      </svg>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between mt-8 gap-4">
          <div className="flex items-center gap-4">
            <button className="bg-gray-200 px-6 py-3 rounded-lg cursor-not-allowed text-lg">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg">
              1
            </button>
            <button className="bg-gray-200 px-6 py-3 rounded-lg text-lg">Next</button>
          </div>
          <div className="flex items-center gap-4 text-lg">
            Show
            <select className="border px-4 py-2 rounded-lg">
              <option>15</option>
              <option>30</option>
              <option>45</option>
            </select>
            items
          </div>
          <span className="text-gray-500 text-lg">1-5 of 5 items</span>
          <button className="bg-gray-200 p-4 rounded-lg">
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 4v16h16M4 4l16 16"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
